module.exports = __webpack_public_path__ + "img/pc.68f1ff9b.webp";